/**
 * Page Loading
 */

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export interface PageLoadingProps {
    message?: string;
}

/**
 * Page-level loading indicator.
 * Used for lazy-loaded pages within the layout.
 */
export function PageLoading({ message }: PageLoadingProps) {
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 400,
                p: 3,
            }}
        >
            <CircularProgress size={40} thickness={4} sx={{ mb: 2 }} />
            {message && (
                <Typography variant="body2" color="text.secondary">
                    {message}
                </Typography>
            )}
        </Box>
    );
}


